import { Injectable } from '@angular/core';
import { Platform } from '@ionic/angular';
import { CrashlyticsService } from './crashlytics.service';
import { IntercomService } from './intercom.service';
import { IterableService } from './iterable.service';
import { GoogleAnalyticsService } from './google-analytics.service';
import { BranchService } from './branch.service';
import { Plugins } from '@capacitor/core';
import { environment } from 'src/environments/environment';

const { PushNotifications } = Plugins;

@Injectable({
    providedIn: 'root'
})
export class AnalyticsService {
    public pervUrl = '';

    constructor(
        private platform: Platform,
        private crashlytics: CrashlyticsService,
        private intercom: IntercomService,
        private iterable: IterableService,
        private gAnalytics: GoogleAnalyticsService,
        private branch: BranchService
    ) {}

    public initialize() {
        if (this.platform.is('hybrid')) {
            this.branch.initializeMobile();
        } else {
            this.branch.initializeWeb();
            this.gAnalytics.initializeWeb();
        }
    }

    public recordException(message: string, code?: number) {
        this.crashlytics.recordException(message, code);
    }

    public logEvent(name: string, data: any) {
        if (!environment.staging) {
            this.gAnalytics.logEvent(name, data);
            this.iterable.logEvent(name, data);
        }
    }

    public async registerUser() {
        this.gAnalytics.setUserId();
        this.intercom.registerUser();
        await this.iterable.registerUser();

        this.initPushToken();
    }

    public initPushToken() {
        if (this.platform.is('hybrid')) {
            PushNotifications.addListener('registration', (token) => {
                this.iterable.refreshToken(token.value);
            });

            PushNotifications.requestPermission().then((result) => {
                if (result.granted) {
                    PushNotifications.register();
                }
            });
        }
    }

    public refreshPushToken(token: string) {
        this.iterable.refreshToken(token);
    }

    public unregisterUser() {
        this.intercom.logout();
        this.iterable.logout();
    }

    public sendAbandonedEvent(car: any) {
        const url = this.pervUrl;
        let eventName = 'listing_abandoned_';

        if (url.includes('vin-info')) {
            eventName += 'vin_requested';
        } else if (url.includes('basic-info')) {
            eventName += 'car_summary';
        } else if (url.includes('car-condition')) {
            eventName += 'condition_ranking';
        } else if (url.includes('show-car-value')) {
            eventName += 'car_value';
        } else if (url.includes('condition-report')) {
            eventName += 'condition_report';
        } else if (url.includes('post-form')) {
            eventName += 'final_page';
        } else {
            eventName += 'photos';
        }

        this.logEvent(eventName, car);
    }

    public openInbox() {
        this.iterable.openInbox();
    }

    public getNumberOfUnreadMessages() {
        return this.iterable.getNumberOfUnreadMessages();
    }
}
